import { makeContextModule } from '@cian/react-utils';

export interface IHoveredOfferContext {
  hoveredOfferGeoHash: string | undefined;
}

export const {
  Context: { Provider: HoveredOfferContextProvider },
  useContext: useHoveredOfferContext,
} = makeContextModule<IHoveredOfferContext>({
  contextName: 'HoveredOfferContext',
});

export interface IHoveredOfferActionsContext {
  onOfferHover: (offerGeoHash: string) => void;
  onOfferBlur: VoidFunction;
}

export const {
  Context: { Provider: HoveredOfferActionsContextProvider },
  useContext: useHoveredOfferActionsContext,
} = makeContextModule<IHoveredOfferActionsContext>({
  contextName: 'HoveredOfferActionsContext',
});
